import { render, staticRenderFns } from "./ContractTerminationForms.vue?vue&type=template&id=3b5dd47c&"
import script from "./ContractTerminationForms.vue?vue&type=script&lang=js&"
export * from "./ContractTerminationForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports